export class Gif {
    name: string;
    url: string;
    embed_url: string;
    original_image: string;
    from_user: string;
    link_to_user: string;
    
    constructor(name?:string, url?:string, embed_url?:string, original_image?:string, from_user?:string, link_to_user?:string ){

        if(name != null){ this.name = name; }
        if(url != null){ this.url = url; }
        if(embed_url != null){ this.embed_url = embed_url; }
        if(original_image != null){ this.original_image = original_image; }
        if(from_user != null){ this.from_user = from_user; }
        if(link_to_user != null){ this.link_to_user = link_to_user; }

    }
}
